module.exports = __webpack_public_path__ + "img/会社概要.8d5ccd33.png";